module.exports = __webpack_public_path__ + "static/media/image_94.09732eed.png";